export default "__VITE_ASSET__CCfu_N4x__"